///<reference types="pixi.js"/>
(PIXI as any).projection = pixi_projection;
